/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { useLocation,useNavigate } from 'react-router-dom';
import DeleteIcon from "src/assets/all-icons/delete-icon.jsx";

import config from '@/config';
import AddArtworks from '@/pages/profile/artlist/artlist-body/options/add-artworks/generic/index';
import { getArtworkArtistDisplayName } from '@/utils/artworkArtists';

import { handleGenericSubmit } from '../../utils';

import ArtworkDisplay from './ArtworkDisplay';

import './ArtworkManager.css';
import '@/shared-components/forms/add-board-content/board-text-body/add-element/add-picture/BoardBodyPicture.css';

const MAX_ARTICLE_ARTWORKS = 5;
const MAX_POST_ARTWORKS = 1;

export default function ArtworkManager({
  open,
  close,
  formState,
  setFormState,
  editableRef,
  textEditorSelector,
  handleArtworkRemove,
  postMode
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedArtworks, setSelectedArtwors] = useState([]);
  const MAX_ARTWORKS = postMode ? MAX_POST_ARTWORKS : MAX_ARTICLE_ARTWORKS;

  const remainingSlots = MAX_ARTWORKS - selectedArtworks;

  // keep your caption/editor state if you still need it:
  const [selectedImage, setSelectedImage] = useState(null);

  // ── when the modal closes, flush the buffered picks into formState ──
  function handleModalClose() {
    if(selectedArtworks.length) {
      const newGroupId   = (formState.post_artworks?.length || 0) + 1; 
      // slug imageUrl caption artworkId
      const groupedArtworks = selectedArtworks.map(artwork => {
        const resolvedArtist = getArtworkArtistDisplayName(artwork);
        const artistName = resolvedArtist === "-" ? "" : resolvedArtist;
        const artworkTitle = artwork.artwork_about?.artwork_title || "";
        return {
          slug: artwork.slug,
          imageUrl: artwork.artwork_media.artwork_main_picture.image_id,
          caption: artistName
            ? `${artworkTitle} by ${artistName}`
            : `${artworkTitle} by Unknown Artist`,
          artworkId: artwork._id,
          artistName,
          artworkTitle,
        };
      });

      const newGroupedArtworks = { groupId: newGroupId, artworks: groupedArtworks };

      const artworks = [...formState.post_artworks, newGroupedArtworks];
  
      setFormState(prev => ({
        ...prev,
        post_artworks: artworks,
      }));

      const containerId = `groupArtwork-${newGroupId}`;

      handleGenericSubmit(textEditorSelector, editableRef, containerId,
        <ArtworkDisplay
          groupedArtworks={newGroupedArtworks}
          onArtworkRemove={handleArtworkRemove}
          previewMode={false}
          navigate={navigate}
          location={location}
        />, postMode);
    }
    close();
    setSelectedArtwors([]);
  }

  return (
    <div className="add-board-artwork-container">
      <AddArtworks
        open={open}
        close={handleModalClose}
        selectedArtworks={selectedArtworks}
        setSelectedArtworks={setSelectedArtwors}
        maxSelectedArtworks={MAX_ARTWORKS}
      />
    </div>
  );
}
